import React from "react";
import { Form, Input, Space, FormInstance } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";

import FormDrawer from "../common/formdrawer";
import CancelButton from "../common/cancelbutton";
import FormButton from "../common/formbutton";

import { LanguageDto } from "../../types/languagetypes";

interface LanguageFormDrawerProps {
    open: boolean;
    editing: LanguageDto | null;
    form: FormInstance;
    onClose: () => void;
    onSave: () => void;
}

const MAX_NAME_LENGTH = 100;
const MAX_NATIVE_NAME_LENGTH = 100;

const LanguageFormDrawer: React.FC<LanguageFormDrawerProps> = ({
    open,
    editing,
    form,
    onClose,
    onSave
}) => {
    const handleClose = () => {
        form.resetFields();
        onClose();
    };

    const footer = (
        <div style={{ textAlign: "right" }}>
            <Space>
                <CancelButton onClick={handleClose} />
                <FormButton
                    title={editing ? "Save" : "Create"}
                    icon={editing ? <EditOutlined /> : <PlusOutlined />}
                    onClick={() => {
                        form
                            .validateFields()
                            .then(() => onSave())
                            .catch(() => { });
                    }}
                />
            </Space>
        </div>
    );

    return (
        <FormDrawer
            title={editing ? "Edit Language" : "Add Language"}
            open={open}
            onClose={handleClose}
            onSave={() => { }}
            form={form}
            footer={footer}
        >
            <Form.Item
                name="name"
                label="Name"
                rules={[
                    { required: true, message: "Name is required" },
                    {
                        max: MAX_NAME_LENGTH,
                        message: `Name cannot exceed ${MAX_NAME_LENGTH} characters`
                    }
                ]}
            >
                <Input
                    maxLength={MAX_NAME_LENGTH}
                    showCount
                    placeholder="Enter language name"
                />
            </Form.Item>

            <Form.Item
                name="nativeName"
                label="Native Name"
                rules={[
                    { required: true, message: "Native name is required" },
                    {
                        max: MAX_NATIVE_NAME_LENGTH,
                        message: `Native name cannot exceed ${MAX_NATIVE_NAME_LENGTH} characters`
                    }
                ]}
            >
                <Input
                    maxLength={MAX_NATIVE_NAME_LENGTH}
                    showCount
                    placeholder="Enter native name"
                />
            </Form.Item>

            <Form.Item
                name="iso639_1"
                label="ISO 639-1"
                rules={[
                    { required: true, message: "ISO 639-1 is required" },
                    { len: 2, message: "Must be exactly 2 characters" }
                ]}
            >
                <Input
                    maxLength={2}
                    placeholder="e.g. en"
                />
            </Form.Item>
        </FormDrawer>
    );
};

export default LanguageFormDrawer;